import React, { createContext, useContext, useState } from 'react';
import useShortCode from '../../hooks/useShortCode';

const BannerContext = createContext({});

const bannerDefaults = {
  open: false,
  type: null,
};

// eslint-disable-next-line react/prop-types
const BannerRenderer = ({ children }) => {
  const shortCode = useShortCode();
  const [bannerOptions, setBannerOptions] = useState([]);

  function handleBanner(shortCode, opts) {
    const bannerIndex = bannerOptions.findIndex(b => b.shortCode === shortCode);
    if (bannerIndex === -1) {
      setBannerOptions([
        ...bannerOptions,
        {
          ...bannerDefaults,
          shortCode,
          ...opts,
        },
      ]);
    } else {
      const newBannerOptions = [...bannerOptions];
      newBannerOptions[bannerIndex] = {
        ...newBannerOptions[bannerIndex],
        ...opts,
      };
      setBannerOptions(newBannerOptions);
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ctx = {
    ...bannerOptions.find(b => b.shortCode === shortCode),
    setShowBanner: (type, opts) => {
      handleBanner(shortCode, {
        open: true,
        type,
        opts,
      });
    },
    setCallId: id => {
      bannerOptions.callId = id;
    },
    reset: () => {
      handleBanner(shortCode, bannerDefaults);
    },
  };

  return <BannerContext.Provider value={ctx}>{children}</BannerContext.Provider>;
};

function useBannerContext() {
  return useContext(BannerContext);
}

export default BannerRenderer;
export { useBannerContext };
